import React, { Component } from "react";
import styled from "styled-components";
import { breakpoints } from "../../Media";
import ResultsCard from "../../components/ResultsCard";
import renderIf from "render-if";
import { colors } from "../../resources/ThemeColors";
import { withRouter } from "react-router-dom";
import { GoogleApiWrapper } from "google-maps-react";
import axios from "axios";

const ResultsCardDiv = styled.div`
  padding-bottom: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: ${breakpoints.mobileMin}) {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
  }
`;

const NoResultsDiv = styled.div`
  height: 30vh;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  margin: 0 2em 0 2em;
`;
const NoResultsText = styled.p`
  font-size: 1em;
  text-align: center;
`;
const Button = styled.button`
  color: ${colors.main};
  background-color: white;
  height: 2.6em;
  border: 1px solid ${colors.main};
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  :hover {
    color: white;
    background-color: ${colors.main};
  }
`;

let API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

class ResultsSection extends Component {
  state = {
    salons: [],
    position: {},
    otherSalons: [],
  };

  componentDidMount() {
    // const newSalons = ResultsSection.getSalonProximity(
    //   this.state.salons,
    //   this.state.position
    // );
  }

  static getDerivedStateFromProps(props, state) {
    if (props.salons !== state.salons) {
      return {
        salons: props.salons,
        position: props.mapQueryPosition,
        // otherSalons: ResultsSection.getSalonProximity(
        //   props.salons,
        //   props.mapQueryPosition
        // ),
      };
    }
    // No state update necessary
    return null;
  }

  goBack = (e) => {
    e.preventDefault();
    this.props.history.goBack();
  };

  static getSalonProximity = (salons, queryLocation) => {
    if (!salons) {
      return;
    } else {
      salons.forEach((element) => {
        if (!element.latitude) {
          element.proximity = 100; // this value should not be too large or too small
        } else {
          axios
            .post(
              `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${queryLocation.lat},${queryLocation.lng}&destinations=side_of_road:${element.latitude},${element.longitude}&units=metric&key=${API_KEY}`
            )
            .then(() => {
              // const res = response.data;
              // console.log("The proximity response", res);
              // create a new property in salon to hold the distance value
              // element.proximity = add the value here;
            })
            .catch(() => {
              // console.log(error);
            });
        }
      });
      return salons;
    }
  };

  render() {
    return (
      <>
        {renderIf(this.state.salons.length !== 0)(
          <ResultsCardDiv>
            {this.state.salons.map((salon) => (
              <ResultsCard salon={salon} />
            ))}
          </ResultsCardDiv>
        )}
        {renderIf(this.state.salons.length === 0)(
          <ResultsCardDiv>
            <NoResultsDiv>
              <NoResultsText>
                Ooops! There are no HairQ Points available in this location.
              </NoResultsText>
              <Button onClick={this.goBack}>Try another location</Button>
            </NoResultsDiv>
          </ResultsCardDiv>
        )}
      </>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: API_KEY,
})(withRouter(ResultsSection));
